import { createSlice } from '@reduxjs/toolkit';
import { changeLanguage } from 'i18next';
import { INITIAL_LANGUAGE_STATE } from '@constants/generic-constants';

const languageChange = (state, lang, orientation = 'ltr') => {
  changeLanguage(lang);
  state.lang = lang;
  state.dir = orientation;
};

const languagesSlice = createSlice({
  name: 'languages',
  initialState: INITIAL_LANGUAGE_STATE,
  reducers: {
    updateLanguage: (state, { payload }) => {
      switch (payload) {
        case 'en':
          languageChange(state, 'en');
          break;
        case 'sa':
          languageChange(state, 'sa', 'rtl');
          break;
        default:
          break;
      }
    },
  },
});

export const { updateLanguage } = languagesSlice.actions;
export default languagesSlice.reducer;
